import AdminLoginCard from '../../containers/AdminLoginCard'
import * as S from './styles'

const AdminLogin = () => {
  return (
    <>
      <S.bgAdmin>
        <div className="d-flex flex-column mx-auto col-10 col-md-6 col-lg-4">
          <AdminLoginCard />
        </div>
      </S.bgAdmin>
    </>
  )
}

export default AdminLogin
